module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/HoldingAlbum-d32d0d671ee029783cf3c4bfbd60bfb2.webp";